export default __webpack_public_path__ + "static/media/V230MAND3.daffcd90.pdf";